export default __webpack_public_path__ + "static/media/configure_zoom_settings.f459af43.png";